export default ( event ) => {
  return {
    event: 'profileInfo',
    actionType: event.actionType,
    profileField: event.profileField,
    detailProfile: event.detailProfile,
  };
};
